'use strict';

const PickerPresenter = require('./picker');
const TimePresenter = require('./time');

class TimePickerPresenter extends PickerPresenter {
  constructor(options, templateName) {
    super(...arguments);
    this.setModule('glive_booking_redesign');
    this.timePresenter = new TimePresenter(options, templateName);
  }

  toHash() {
    const hash = super.toHash(...arguments);
    hash.isTouch = this.collection.meta('isTouch');
    const selected = this.selected();
    if (selected) {
      const timeHash = this.timePresenter.modelToHash(selected);
      hash.selection = timeHash ? timeHash.time : undefined;
    }
    return hash;
  }
}

module.exports = TimePickerPresenter;
